import HttpClient from '@/util/http/HttpClient';
import { Observable } from 'rxjs';
import Resource from '@/repositories/Resource';
import AccountViewStatus from '@/repositories/data/accountview/AccountViewStatus';
import ApiWrapper from '@/repositories/data/ApiWrapper';
import { networkBoundResource, unwrapApiWrapper } from '@/repositories/BaseCrudRepository';
import AccountViewFlowStart from '@/repositories/data/accountview/AccountViewFlowStart';

export default class AccountViewRepository {
    protected readonly client: HttpClient;
    protected readonly baseUrl: string;

    public constructor(client: HttpClient) {
        this.client = client;
        this.baseUrl = process.env.VUE_APP_API_ENDPOINT + '/api/rest/admin/accountview';
    }

    public getStatus(): Observable<Resource<AccountViewStatus>> {
        const observable = this.client.get<ApiWrapper<AccountViewStatus>>('status', {
            baseUrl: this.baseUrl,
        });
        return networkBoundResource(unwrapApiWrapper(observable));
    }

    public getAuthenticateFlowStart(): Observable<Resource<AccountViewFlowStart>> {
        const observable = this.client.get<ApiWrapper<AccountViewFlowStart>>('authenticate', {
            baseUrl: this.baseUrl,
        });
        return networkBoundResource(unwrapApiWrapper(observable));
    }

    public makeFullAuthenticateUrl(path: string) {
        return process.env.VUE_APP_API_ENDPOINT + path;
    }
}
